import { render, staticRenderFns } from "./ConfirmMassPlaceOrderModal.vue?vue&type=template&id=f6fc79fe&"
import script from "./ConfirmMassPlaceOrderModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmMassPlaceOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports